export default __webpack_public_path__ + "static/media/left-menu.a951c169.svg";